import { render, staticRenderFns } from "./NewCustomerInvoiceEdit.vue?vue&type=template&id=e383c2bc"
import script from "./NewCustomerInvoiceEdit.vue?vue&type=script&lang=js"
export * from "./NewCustomerInvoiceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports